export var SigningType;
(function (SigningType) {
    SigningType["RAW"] = "raw";
    SigningType["OPERATION"] = "operation";
    SigningType["MICHELINE"] = "micheline"; // "05" prefix
})(SigningType || (SigningType = {}));
//# sourceMappingURL=SigningType.js.map